import {createSelector} from '@reduxjs/toolkit'

const suretyBondSelector = createSelector(
    [state => state.components, 
        state => state.primaryAgencyApplication],
    ({suretyBond}, primaryAgencyApplication) => {
        const appData = primaryAgencyApplication.application?.businessLicenceData

        return {
            ...suretyBond,
            confirmSuretyBond : appData?.confirmSuretyBond
        }
    }
)

export const suretyBondSelect = (state) => ({
    suretyBond : suretyBondSelector(state)
}) 
